import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import lottieWeb from 'lottie-web'

export const initLottieAnimations = () => {
	const containers = document.querySelectorAll('[data-lottie]')

	if (!containers.length) return

	containers.forEach(container => {
		const name = container.dataset.lottie
		const loaded = container.getAttribute('data-lottie-loaded')

		if (loaded === 'true') return

		ScrollTrigger.create({
			trigger: container,
			start: 'top bottom',
			end: 'top bottom',
			once: true,
			onEnter: () => {
				const src = container.dataset.lottieSrc
				const anim = lottieWeb.loadAnimation({
					container: container,
					loop: true,
					autoplay: true,
					renderer: 'svg',
					path: src,
					rendererSettings: {
						progressiveLoad: true
					}
				})

				container.setAttribute('data-lottie-loaded', 'true')

				anim.playSegments([45, 208], true)
				
				anim.addEventListener('loopComplete', () => {
					anim.playSegments([45, 208], true)
				})
			}
		})
	})
}

export default () => {}